import { render, staticRenderFns } from "./SousCategorie.vue?vue&type=template&id=438a9bf8"
import script from "./SousCategorie.vue?vue&type=script&lang=js"
export * from "./SousCategorie.vue?vue&type=script&lang=js"
import style0 from "./SousCategorie.vue?vue&type=style&index=0&id=438a9bf8&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports